import { Button, CopyField } from '@/shared/components';
import { useTranslation } from 'react-i18next';

type Props = {
  id: string;
  authenticationType: string;
  access: string;
  onEdit: () => void;
  onDelete: () => void;
};

export const ApiTokenItem = ({
  id,
  authenticationType,
  access,
  onEdit,
  onDelete,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-[2.4rem] px-[2.4rem] py-[1.6rem] bg-muted rounded-[1.6rem] w-full">
      <div className="flex flex-col gap-[0.2rem]">
        <label className="p4 text-muted-foreground">
          {t('webApiTokens.fieldLabels.id')}
        </label>
        <CopyField value={id} variant="compact" />
      </div>

      <div className="flex gap-[1.6rem] items-center">
        <div className="flex flex-col gap-[0.2rem] flex-1">
          <label className="p4 text-muted-foreground">
            {t('webApiTokens.fieldLabels.authenticationType')}:
          </label>

          <span className="headline4 text-primary break-all">
            {authenticationType}
          </span>
        </div>

        <div className="flex flex-col gap-[0.2rem] flex-1">
          <label className="p4 text-muted-foreground">
            {t('webApiTokens.fieldLabels.accessRights')}:
          </label>

          <span className="headline4 text-primary break-all">{access}</span>
        </div>
      </div>

      <div className="flex gap-[1.6rem] items-center">
        <Button
          variant="secondary"
          className="flex-1 h-[4.2rem] rounded-[1.2rem] bg-stroke"
          onClick={onEdit}>
          <span className="headline4 text-primary">
            {t('webApiTokens.editing.buttonText')}
          </span>
        </Button>

        <Button
          variant="secondary"
          className="flex-1 h-[4.2rem] rounded-[1.2rem] bg-stroke"
          onClick={onDelete}>
          <span className="headline4 text-red">
            {t('webApiTokens.deletion.buttonText')}
          </span>
        </Button>
      </div>
    </div>
  );
};
